import { useModalStore } from '@/stores';
import { Button } from '@/components/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import styles from './DeleteConfirmationModal.module.css';

interface DeleteConfirmationModalProps {
  title: string;
  itemName: string;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export function DeleteConfirmationModal({
  title,
  itemName,
  onConfirm,
  isDeleting = false,
}: DeleteConfirmationModalProps) {
  const { closeModal } = useModalStore();

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={faExclamationTriangle} className={styles.icon} />
      </div>

      <h3 className={styles.title}>{title}</h3>

      <p className={styles.message}>
        Are you sure you want to delete <strong>{itemName}</strong>?
      </p>

      <p className={styles.subtext}>This action cannot be undone.</p>

      <div className={styles.actions}>
        <Button variant="secondary" onClick={closeModal} disabled={isDeleting}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </div>
    </div>
  );
}
